import {
    setRawMaterialCategories,
    addRawMaterialCategory,
    updateRawMaterialCategory,
    deleteRawMaterialCategory,
    setLoading
} from "./rawMaterialCategorySlice";

import { getMethod, postMethod, putMethod, deleteMethod } from "../../api-service/api-service";

// GET ALL (PAGINATED)
export const fetchAllRawMaterialCategoryAction = (page = 1, limit = 10) => async (dispatch) => {
    try {
        dispatch(setLoading(true));

        const response = await getMethod(
            `/raw-material-category?page=${page}&limit=${limit}`
        );

        dispatch(setRawMaterialCategories(response));
        dispatch(setLoading(false));

        return response;
    } catch (error) {
        dispatch(setLoading(false));
        return { success: false, message: error };
    }
};

// CREATE
export const createNewRawMaterialCategoryAction = (data) => async (dispatch) => {
    try {
        const response = await postMethod(`/raw-material-category`, data);

        if (response?.data) {
            dispatch(addRawMaterialCategory(response.data));
        }

        return response;
    } catch (error) {
        return { success: false, message: error };
    }
};

// UPDATE
export const updateRawMaterialCategoryAction = (id, data) => async (dispatch) => {
    try {
        const response = await putMethod(`/raw-material-category/${id}`, data);

        if (response?.data) {
            dispatch(updateRawMaterialCategory(response.data));
        }

        return response;
    } catch (error) {
        return { success: false, message: error };
    }
};

// DELETE
export const deleteRawMaterialCategoryAction = (id) => async (dispatch) => {
    try {
        const response = await deleteMethod(`/raw-material-category/${id}`);

        dispatch(deleteRawMaterialCategory(id));

        return response;
    } catch (error) {
        return { success: false, message: error };
    }
};
